import React from 'react'

export const DashProd = () => {
  return (
    <div>DashProd</div>
  )
}
